<template>
  <div
    class="analysisThreadCard d-flex flex-row"
    @click="clicked"
  >
    <v-icon small dense color="#3C44C8">
      fa-gem
    </v-icon>
    <span class="ml-1">
      {{ averageStars }}
    </span>
    <v-icon class="ml-2" small dense>
      question_answer
    </v-icon>
    <span class="ml-1">
      {{ summaryContributions }}
    </span>
    <!-- {{ contributions }} {{ $t('extension.analysisSelector.contributions') }} -->

    <v-spacer />
    <AnalysisAvatars
      :analysis="analysis"
      :user-analyses="analysis.userAnalyses"
      :show-badge="false"
      :show-number-of-extra-avatars="true"
      max-avatars="5"
      overlap="-12px"
      class="mr-2"
    />
    <div class="d-flex flex-column justify-center" style="min-width:120px;">
      <!-- <div class="d-flex flex-column" style="min-width:120px;"> -->
      <!--span class="participants ml-2 align-self-start">
        {{ participants }} {{ $t('extension.summary.participants') }}
      </span-->

      <span class="lastModified ml-2 align-self-start">
        {{ $t('extension.userAnalyses.events.modified') }} {{ getMoment(analysis.lastEdited) }}
      </span>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import AnalysisAvatars from './AnalysisAvatars';

export default {
  name: 'AnalysisThreadCard',
  components: { AnalysisAvatars },
  props: {
    analysis: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      participants: 'X',
    };
  },
  created() {
    console.log('[into AnalysisThreadCard] analysis: ', this.analysis);
  },
  computed: {
    averageStars() {
      if (!this.analysis.summary) return 'n/a';

      const averageStars = this.analysis.summary.evaluationAverage / 20;
      return parseFloat(averageStars).toFixed(1);
    },
    summaryContributions() {
      if (!this.analysis.summary) return '';

      const count = this.analysis.summary.activityCount;
      const message = count > 1
        ? this.$t('extension.analysisSelector.contributionsPlural')
        : this.$t('extension.analysisSelector.contributionsSingular');

      return `${count} ${message}`;
    },
  },
  methods: {
    clicked() {
      this.$emit('click', this.analysis);
    },
    getMoment(timestamp) {
      return moment(timestamp).fromNow();
    },
  },
};
</script>

<style scoped>
span {
  align-self: center;
}
.participants {
  color: #3F47CD;
  font-weight: 600;
}
.analysisThreadCard {
  font-size: 10px;
}
.analysisThreadCard:hover {
  background-color: #F6F5FA;
}
.lastModified {
  color: #0000008C;
  font-size: 10px;
}
</style>
